module.exports = __webpack_public_path__ + "static/media/faqs.2349a33b.png";